import apiClient from './api';

export const getDocument = async (id: string) => {
  const response = await apiClient.get(`/document/${id}`);
  return response.data;
}

export const getDocumentsByModule = async (moduleId: number) => {
  const response = await apiClient.get(`/document/module/${moduleId}`);
  return response.data;
}

export const createDocument = async (document: any) => {
  const response = await apiClient.post(`/document`, document);
  return response.data;
}

export const updateDocument = async (id: number, document: any) => {
  const response = await apiClient.put(`/document/${id}`, document);
  return response.data;
}